import { isValidEmail } from "@/utils/validation";
import { DSField, DSInput, DSTestLandingPage } from "@hundred5/design-system";
import { useLingui } from "@lingui/react/macro";
import { ReactElement, useState } from "react";
import { useAsyncFn } from "react-use";

interface Props {
  primary?: boolean;
  onSubmit: (email: string) => Promise<void>;
}

export default function EmailLoginForm({
  primary,
  onSubmit,
}: Props): ReactElement {
  const { t } = useLingui();
  const [showEmailInput, setShowEmailInput] = useState(false);
  const [showError, setShowError] = useState(false);
  const [email, setEmail] = useState("");

  const [{ loading }, asyncOnSubmit] = useAsyncFn(onSubmit);

  const handleLogIn = () => {
    if (!isValidEmail(email)) {
      setShowError(true);
      return;
    }
    asyncOnSubmit(email);
  };

  return (
    <>
      {showEmailInput && (
        <DSField
          for="email"
          label={t`Email`}
          error={
            showError && !isValidEmail(email)
              ? t`Enter a valid email address`
              : undefined
          }
        >
          <DSInput
            id="email"
            value={email}
            disabled={loading}
            error={showError && !isValidEmail(email)}
            onChange={(e) => setEmail(e.currentTarget.value)}
          />
        </DSField>
      )}

      <DSTestLandingPage.LoginButton
        method="other"
        primary={primary}
        label={t`Log in with email`}
        onClick={() => {
          if (showEmailInput) {
            handleLogIn();
          } else {
            setShowEmailInput(true);
          }
        }}
        disabled={loading}
      />
    </>
  );
}
